import { Col, Container, Row } from 'react-bootstrap'
import "./Dth_operators.css"

const Dth_operators = () => {
    return (
        <section className='operators-section'>
            <Container>
                <div className='operators-heading'>
                    <h4 className='heading'>ALL MAJOR DTH OPERATORS IN ONE PLACE</h4>
                    <p className='subheading'>Select your provider & enjoy quick, seamless recharges.</p>
                </div>
                <Row className='justify-content-center text-center mt-4'>
                    <Col md={3} sm={6} xs={12}>
                        <div className='operator-card'>
                            <div className='operator-logo'>
                                <img src='./assets/images/services/dth_providers/tata-sky.png' alt='tata-sky' className='logo' />
                            </div>
                            <div className='operator-name' >
                                <p className='name'>Tata Play (Formerly Tata Sky)</p>
                            </div>
                        </div>
                    </Col>

                    <Col md={3} sm={6} xs={12}>
                        <div className='operator-card'>
                            <div className='operator-logo'>
                                <img src='./assets/images/services/dth_providers/airtel.png' alt='airtel' className='logo' />
                            </div>
                            <div className='operator-name' >
                                <p className='name'>Airtel Digital TV</p>
                            </div>
                        </div>
                    </Col>

                    <Col md={3} sm={6} xs={12}>
                        <div className='operator-card'>
                            <div className='operator-logo'>
                                <img src='./assets/images/services/dth_providers/dishtv.png' alt='dish-tv' className='logo' />
                            </div>
                            <div className='operator-name' >
                                <p className='name'>Dish TV</p>
                            </div>
                        </div>
                    </Col>

                    <Col md={3} sm={6} xs={12}>
                        <div className='operator-card'>
                            <div className='operator-logo'>
                                <img src='/assets/images/services/dth_providers/d2h.png' alt='D2H' className='logo' />
                            </div>
                            <div className='operator-name' >
                                <p className='name'>d2h</p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default Dth_operators